import { chordFor, hits, type Style } from '../style';

/** Sunday gospel: organ chords, handclaps and tambourine, a walking bass. */
const CHORDS = [[60, 64, 67], [65, 69, 72], [67, 71, 74], [60, 64, 67]]; // C F G C

export const GOSPEL: Style = {
  bpm: 100,
  swing: 0.15,
  play(kit, step, bar, t, len) {
    const chord = chordFor(CHORDS, bar);
    if (hits('x.......x.......', step)) kit.kick(t, 0.8);
    if (hits('....x.......x...', step)) kit.clap(t, 1);
    if (step % 2 === 1) kit.shaker(t, 0.7);
    if (step % 4 === 0) kit.bass(t, (chord[step / 4] ?? chord[0] ?? 60) - 24, len * 3);
    if (step === 0 || step === 8) kit.organ(t, chord, len * 7);
  },
};
